/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_HintInputs */

const en_directory_submit_enrich_hint = /** @type {(inputs: Directory_Submit_Enrich_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The pipeline is running — each stage appears here as it starts. Typically 1-2 minutes.`)
};

const zh_directory_submit_enrich_hint = /** @type {(inputs: Directory_Submit_Enrich_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流水线运行中——每个环节开始后会在此显示，通常需要 1-2 分钟。`)
};

/**
* | output |
* | --- |
* | "The pipeline is running — each stage appears here as it starts. Typically 1-2 minutes." |
*
* @param {Directory_Submit_Enrich_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_hint = /** @type {((inputs?: Directory_Submit_Enrich_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_hint(inputs)
	return zh_directory_submit_enrich_hint(inputs)
});
export { directory_submit_enrich_hint as "directory.submit.enrich.hint" }